import { gql } from '@apollo/client'
import { DISPLAY_AUDIT_FRAGMENT, PRICING_ERROR_FRAGMENT } from '../fragments'

export const GET_PICOS_AUDITS_FOR_STORE = gql`
  query GetPicosAuditsForStore($input: PicOSAuditsForStoreInput!) {
    picosAuditsForStore(input: $input) {
      hasMore
      count
      results {
        id
        created
        complianceScore
        displayAudit {
          ...DisplayAudit
          pricingErrors {
            ...PricingError
          }
        }
        picosPriority {
          id
          name
        }
        employee {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
  ${DISPLAY_AUDIT_FRAGMENT}
  ${PRICING_ERROR_FRAGMENT}
`
